import { render, staticRenderFns } from "./removeSite.vue?vue&type=template&id=6d00055b&"
import script from "./removeSite.vue?vue&type=script&lang=js&"
export * from "./removeSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports